import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";

export default function PublicVerifyCertificate() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get(`/public/verify/${code}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [code]);
  if (loading) return <div className="min-h-screen flex items-center justify-center overline">Verificando…</div>;
  const brand = data?.brand || {};
  const primary = brand.brand_primary || "#C07C88";
  const gold = brand.brand_accent || "#D4AF37";
  const valid = data?.valid;
  const cert = data?.certificate;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4 py-10">
      <div className="max-w-lg w-full">
        <Card className="p-10 border-border shadow-none text-center">
          {valid ? (
            <>
              <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center" style={{ background: `${gold}15` }}>
                <ShieldCheck size={32} strokeWidth={1.5} style={{ color: gold }} />
              </div>
              <p className="overline mt-6" style={{ color: gold }}>Certificado Autêntico</p>
              <h1 className="font-heading text-3xl mt-3" style={{ color: primary }}>{cert.participant_name}</h1>
              <p className="text-sm text-muted-foreground mt-2">concluiu com aproveitamento</p>
              <p className="font-heading text-xl mt-2">{cert.training_title}</p>
              <div className="grid grid-cols-2 gap-4 mt-6 py-4 border-y border-border">
                <div>
                  <p className="overline">Nota</p>
                  <p className="font-heading text-2xl mt-1" style={{ color: gold }}>{cert.grade}%</p>
                </div>
                <div>
                  <p className="overline">Frequência</p>
                  <p className="font-heading text-2xl mt-1" style={{ color: gold }}>{cert.attendance_pct}%</p>
                </div>
              </div>
              <p className="text-xs text-muted-foreground mt-4">Código: <span className="font-mono">{cert.verification_code}</span></p>
              <p className="text-xs text-muted-foreground">Emitido em {cert.issued_at?.slice(0, 10)}</p>
              <div className="mt-6 pt-6 border-t border-border">
                <p className="text-xs text-muted-foreground">Emitido por</p>
                <p className="font-heading text-lg" style={{ color: primary }}>{brand.company_name}</p>
              </div>
            </>
          ) : (
            <>
              <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center bg-red-50">
                <XCircle size={32} strokeWidth={1.5} className="text-red-500" />
              </div>
              <p className="overline mt-6 text-red-500">Certificado Inválido</p>
              <p className="mt-3 text-sm text-muted-foreground">Nenhum certificado encontrado com o código <span className="font-mono">{code}</span>. Se você recebeu este QR/link, verifique com a instituição emissora.</p>
            </>
          )}
        </Card>
        <p className="text-center text-xs text-muted-foreground mt-6">Validação pública Leadera</p>
      </div>
    </div>
  );
}
